import request from "@/util/http";
import qs from "qs"; // 任务列表

export function tHallBatchReportList(query) {
  return request({
    url: "/admin/tHallBatchReport/list",
    method: "get",
    params: query
  });
} // 新建任务

export function tHallBatchReportSaveOrUpdate(data, type) {
  return request({
    url: type === "add" ? "/admin/tHallBatchReport/save" : "/admin/tHallBatchReport/update",
    method: "post",
    data: data
  });
} // 任务人员

export function tHallBatchReportListUsers(query) {
  return request({
    url: "/admin/tHallBatchReport/listUsers",
    method: "get",
    params: query
  });
} // 修改任务状态

export function tHallBatchReportStatus(data) {
  return request({
    url: "/admin/tHallBatchReport/status",
    method: "post",
    data: data
  });
} // 追加任务人员

export function tHallBatchReportSaveUsers(data) {
  return request({
    url: "/admin/tHallBatchReport/saveUsers",
    method: "post",
    data: data
  });
} // 删除人员

export function tHallBatchReportDeleteUsers(data) {
  return request({
    url: "/admin/tHallBatchReport/deleteUsers",
    method: "post",
    data: qs.stringify(data)
  });
} // 删除人员

export function deleteReportId(query) {
  return request({
    url: "/admin/tHallBatchReport/delete",
    method: "post",
    params: query
  });
}